export const zettleBrandLogoPrimaryPositive =
  "https://cdn.izettle.com/zettle-brand/Zettle_Primary_Positive.svg"
